import { Stack } from '../../../../shared/ui/Stack/Stack';
import { Text } from '../../../../shared/ui/Text/Text';
import styles from './FooterInfo.module.scss';
import logo from '../../../../shared/assets/photo/logo.png'
import { Link } from 'react-router-dom';
import { useState } from 'react';

const FooterInfo = () => {
    const [isOpen, setOpen] = useState();

    const handleClik = () => { 
        setOpen(!isOpen)
      }

    return (
        <section>
        <div className={styles.container}>
            <Stack
                    justifyContent = 'justifyBetween' 
                    alignItems = 'alignEnd'
                    gap='16'
                    className={styles.footerInfo} 
                >
                <Stack
                    direction = 'column'
                    gap = '16'
                    justifyContent = 'justifyBetween'
                    alignItems = 'alignStart' >
                    <div>
                        <img className={styles.logo} src={logo} alt="logo"/>
                    </div>
                    <Text size='xs' className={styles.text1}>
                        © 2026 ИП Верюжский А.А. <br/> Все права защищены
                    </Text>
                </Stack>
                    <Text size='xs' className={styles.text2}>Информация, размещенная на сайте,  носит информационный характер. Постановка диагноза и план лечения остается за лечащим врачом!
                        Стоимость лечения и прайс-лист не являются публичной офертой. Мы стараемся своевременно обновлять информацию на сайте, однако  актуальные данные о ценах, акциях и предложениях уточняйте по телефону  +7 928 840 80 20</Text>
                    <Link onClick={handleClik} to="/personal" className={styles.textAccent}>
                        соглашение об обработке <br/>персональных данных
                    </Link>
            </Stack>
        </div> 
            <div className={styles.container}>   
                <Stack
                    justifyContent = 'justifyBetween'                  
                    gap='16'
                    className={styles.details}>     
                    <Text size='xs' className={styles.footer__data}>
                        ИП Верюжский А.А., ИНН 230209175705, ОГРН 325237500438782
                    </Text>           
                    <Text size='xs'className={styles.footer__data}>
                        Лицензия на осуществление медицинской деятельности Л041-01126-23/04351068 от 12.02.2026. 
                    </Text>
                </Stack> 
            </div>
        </section>
    );
}
export default FooterInfo;